import React from "react";
import styled from "@emotion/styled";
import SkeletonLoader from "@components/SkeletonLoaderBrandPage";

const ImageContainer = styled.div`
  width: 139px;
  height: 90px;
  margin: 0 auto;
  background-size: cover;
  position: relative;

  @media (max-width: 1750px) {
    width: 66%;
  }
  @media (max-width: 400px) {
    height: 80px;
  }
  @media (max-width: 341px) {
    height: 70px;
  }
`;

const Image = styled.img`
  width: 139px;
  height: 90px;
  box-shadow: 0 22px 32px 0px rgba(119, 121, 132, 0.15);
  opacity: ${props => props.opacity};
  filter: ${props => props.filter};
  display: ${props => props.setDisplay};
  z-index: 1;
  position: relative;
  @media (max-width: 1750px) {
    width: 100%;
    height: auto;
  }
`;

const SkeletonLoaderContainer = styled.div`
  position: absolute;
  overflow: hidden;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  z-index: 0;

  @media (max-width: 1500px) {
    max-height: 80px;
  }
  @media (max-width: 1400px) {
    max-height: 70px;
  }
  @media (max-width: 1300px) {
    max-height: 90px;
  }
  @media (max-width: 1050px) {
    max-height: 80px;
  }
  @media (max-width: 925px) {
    max-height: 90px;
  }
  @media (max-width: 850px) {
    max-height: 80px;
  }
  @media (max-width: 700px) {
    max-height: 70px;
  }
  @media (max-width: 600px) {
    max-height: 65px;
  }
  @media (max-width: 575px) {
    max-height: 90px;
  }
  @media (max-width: 490px) {
    max-height: 80px;
  }
  @media (max-width: 440px) {
    max-height: 70px;
  }
  @media (max-width: 375px) {
    max-height: 60px;
  }
  @media (max-width: 325px) {
    max-height: 55px;
  }
  @media (max-width: 320px) {
    max-height: 40px;
  }
`;

const DiscountCardImage = ({ cardsAvailable, img, name }) => (
  <ImageContainer>
    <Image
      opacity={cardsAvailable < 1 ? 0.3 : 1}
      filter={cardsAvailable < 1 ? "grayscale(100%)" : "none"}
      src={img}
      alt={`${name} Gift Card`}
      loading="lazy"
    />
    <SkeletonLoaderContainer>
      <SkeletonLoader width={200} height={90} viewBox={"0 0 200 90"}>
        <rect x="0" y="0" rx="5" ry="5" width="200" height="90" />
      </SkeletonLoader>
    </SkeletonLoaderContainer>
  </ImageContainer>
);

export default DiscountCardImage;
